<template>
  <div>
    <div v-if="view">
      <div class="col-md-8 col-md-offset-2">
        <h4 class="text-center">
          {{computeCaption(fields_en['please_tell_us_more_about_yourself'], this.$store.state.lang.value.toLowerCase())}}
        </h4>
        <br />
        <!-- dependent -->
        <div v-if="optionsArray.length <= 4" class="row mt-5" :class="[validatedSectionClass, generalClass]">
          <div class="col-md-2 col-md-offset-1 pl-5 pr-5">
            <div class="form-group mt-10 mb-0">
              <label
                class="control-label"
                :class="
                  modelValidations.dependent['required'] ? 'required' : ''
                "
                for="dependent"
              >
                {{computeCaption(fields_en['patient'], this.$store.state.lang.value.toLowerCase())}}
              </label>
            </div>
          </div>
          <div class="col-md-8 patient-float">
            <div class="form-group">
              <el-radio-group
                size="small"
                data-vv-as="Dependent"
                id="Dependent"
                v-validate="modelValidations.dependent"
                placeholder="Single Select"
                name="Dependent"
                v-model="model.dependent"
              >
                <el-radio-button
                  v-for="option in optionsArray"
                  :value="option.name"
                  :label="option.name"
                  :key="option.name"
                  tabindex="0"
                >
                {{option.name === 'Self' ? computeCaption(fields_en['self'], $store.state.lang.value.toLowerCase()) : option.name}}
                </el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div class="col-md-10 col-md-offset-1">
            <div class="form-group">
              <small class="text-danger col-md-0" v-show="dependent.invalid">
                {{dependentError && computeCaption(dependentError, this.$store.state.lang.value.toLowerCase())}}
              </small>
            </div>
          </div>
        </div>

        <div v-if="optionsArray.length > 4" class="row" :class="[validatedSectionClass, generalClass]">
          <div class="col-md-10 col-md-offset-1 pl-5 pr-5">
            <div class="form-group">
              <label
                class="control-label"
                :class="
                  modelValidations.dependent['required'] ? 'required' : ''
                "
                for="dependent"
              >
                {{computeCaption(fields_en['patient'], this.$store.state.lang.value.toLowerCase())}}
              </label>
              <el-select
                size="large"
                id="member1"
                data-vv-as="Dependent"
                v-validate="modelValidations.dependent"
                placeholder="Single Select"
                name="gender"
                v-model="model.dependent"
              >
                <el-option
                  v-for="option in optionsArray"
                  class="select-danger"
                  :value="option['name']"
                  :label="option['name'] === 'Self' ? computeCaption(fields_en['self'], $store.state.lang.value.toLowerCase()) : option['name']"
                  :key="option['name']"
                >
                </el-option>
              </el-select>
            </div>
            <small class="text-danger" v-show="dependent.invalid">
              {{dependentError && computeCaption(dependentError, this.$store.state.lang.value.toLowerCase())}}
            </small>
          </div>

          <div class="col-md-10 col-md-offset-1">
            <div class="form-group">
              <small class="text-danger col-md-0" v-show="dependent.invalid">
                {{dependentError && computeCaption(dependentError, this.$store.state.lang.value.toLowerCase())}}
              </small>
            </div>
          </div>
        </div>

        <transition name="fade">
          <div v-if="newDependentSelected">
            <MedicationData type="Registration" ref="MedicalData" :triggerWatch="true">
            </MedicationData>
          </div>
        </transition>
        <!--Questions-->
        <QuestionsSection ref="questions" section="main"></QuestionsSection>
        <transition name="fade">
          <div v-if="newDependentSelected">
            <Insurance ref="Insurance"  v-if="allow_insurance"> </Insurance>
          </div>
        </transition>

        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <small class="text-danger" v-if="errorSave">
              {{computeCaption(errorSave, this.$store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>

      <div>
        <ConsentDisclaimer :submit="submit" ref="ConsentDisclaimer" />
      </div>
        <br>
        <div v-if="($store.state.configs['FORCE_PAYMENT_ON_REGISTRATION'] === true && $store.state.insuranceType === 'cash' && $store.state.cashPayment === 'card') || $store.state.configs['AT_HOME_COLLECTION'] === true"> <payment-section ref="paymentSectionVisible"></payment-section></div>
        <br>
        <ScheduleSection v-if="this.$store.state.site.schedule.data.length && this.$store.state.configs.ALLOW_SCHEDULES" ref="ScheduleSection"/>
        <br/>
        <div class="row">
          <div class="col-md-10 col-md-offset-1 button-container">
            <button
              class="btn btn-default btn-wd btn-back primary-color back-button"
              v-on:click.stop.prevent="
                $router.push({ path: '/patient/account' })
              "
            >
              <span>
                {{computeCaption(fields_en['back'], this.$store.state.lang.value.toLowerCase())}}
              </span>
            </button>
            <button
              class="btn btn-fill btn-wd btn-next float-right next-button"
              v-on:click.stop.prevent="callValidation()"
              :disabled="disabledButton === true"
            >
              <span v-if="disabledButton === false">
               {{computeCaption(fields_en['register'], this.$store.state.lang.value.toLowerCase())}}
              </span>
              <span v-else>
               {{computeCaption(fields_en['submitting'], this.$store.state.lang.value.toLowerCase())}}
              </span>
            </button>
          </div>
        </div>
        <br /><br />
      </div>
    </div>
    <div v-else v-loading.fullscreen.lock="!view" class="loading"></div>
  </div>
</template>

<script>
  import {mapFields} from 'vee-validate'
  import {Autocomplete, Input, Button, RadioGroup, Radio, RadioButton, DatePicker, CheckboxGroup, CheckboxButton} from 'element-ui'
  import {FormatterUtils} from '../../../../../utils/Formatter.js'
  import {ValidationUtils} from '../../../../../utils/Validation.js'
  import axios from 'axios'
  import Address from './Address'
  import RecursiveQuestions from './RecursiveQuestions'
  import MedicationData from './MedDataRegistration'
  import Insurance from './InsuranceRegistration'
  import swal from 'sweetalert2'
  import ConsentDisclaimer from '../../Utils/ConsentDisclaimer.vue'
  import QuestionsSection from '../../Utils/QuestionsSection'
  import VueBarcode from 'vue-barcode'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  import {SettingsUtils} from '../../../../../utils/SiteConfigurations'
  import {PatientInfoUtils} from '../../../../../utils/PatientInfo'
  import PaymentSection from '../../Utils/PaymentSection.vue'
  import _ from 'lodash'
  import ScheduleSection from '../../Utils/ScheduleSection'
  import {QuestionUtils} from '../../../../../utils/Questions'
  require('cleave.js/dist/addons/cleave-phone.us')
//  PATIENT NAME
//  PATIENT ADDRESS
//  PATIENT SEX
//  PATIENT DOB
//  PATIENT PHONE NUMBER
//  PATIENT EMAIL ADDRESS
//  PATIENT INSURANCE DETAILS
  export default {
    components: {
      ScheduleSection,
      [Input.name]: Input,
      [DatePicker.name]: DatePicker,
      [Autocomplete.name]: Autocomplete,
      [Button.name]: Button,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [RadioButton.name]: RadioButton,
      [CheckboxButton.name]: CheckboxButton,
      [CheckboxGroup.name]: CheckboxGroup,
      Address,
      'recursive-question': RecursiveQuestions,
      MedicationData,
      Insurance,
      QuestionsSection,
      ConsentDisclaimer,
      PaymentSection,
      'barcode': VueBarcode
    },
    mixins: [FormatterUtils, ValidationUtils, TranslationsUtils, SettingsUtils, PatientInfoUtils, QuestionUtils],
    data () {
      return {
        generalClass: 'general-inactive-section',
        validatedSectionClass: '',
        redirectUrl: '',
        confirmationNumber: '',
        disabledButton: false,
        signature: '',
        submit: false,
        view: false,
        newDependentSelected: false,
        finalResponse: {},
        dependentError: '',
        optionsArray: [{name: 'Self'}],
        suggestions: [],
        answers_es: {},
        answers_zh: {},
        requirements: [],
        questionError: '',
        errorDate: '',
        errorSave: '',
        client_bill_translation: '',
        paymentMethod: 'card',
        questionErrorDate: [],
        answer_no: 'No',
        amount: this.$store.state.configs.PAYMENT_AMOUNT,
        allow_payment: this.isTrue(this.$store.state.configs.ALLOW_PAYMENT),
        allow_insurance_card: this.isTrue(this.$store.state.configs.ALLOW_INSURANCE_CARD),
        required_insurance_card: this.isTrue(this.$store.state.configs.REQUIRED_INSURANCE_CARD),
        allow_above_medication_text: this.$store.state.configs.ALLOW_ABOVE_MEDICATION_TEXT,
        fields_en: {
          all_questions: 'All questions are required',
          self: 'Self',
          back: 'Back',
          register: 'Register',
          client_bill: 'Client Bill',
          select_payment_type: 'Select Payment Type',
          insurance: 'Insurance',
          uninsured: 'Uninsured',
          cash: 'Cash',
          please_provide_payment_information: 'Please Provide Payment Information',
          primary_insurance_name: 'Primary Insurance Name',
          policy_number: 'Policy Number',
          group_number: 'Group Number',
          insurance_card: 'Insurance Card',
          patient_relationship_to_insured: 'Patient Relationship to Insured',
          note: 'Note',
          after_registration_you_will_be_redirected_to_a_payment_page: 'After registration you will be redirected to a payment page',
          social_security_number: 'Social Security Number',
          driver_license_number: 'Driver License Number',
          patient: 'Select patient',
          please_tell_us_more_about_yourself: 'Please tell us more about yourself',
          submitting: 'Submitting... please wait'
        },
        model: {
          dependent: '',
          note: '',
          questions: this.$store.state.questions
        },
        modelValidations: {
          dependent: {
            required: true
          }
        }
      }
    },
    methods: {
      customizer (objValue, srcValue) {
        if (objValue) {
          return objValue
        } else {
          return srcValue
        }
      },
      redirectHome () {
        const body = document.querySelector('body')
        body.onclick = function () {
          window.location.href = window.origin + '/#/'
          window.location.reload()
        }
      },
      async callValidation () {
        let info = await this.getPatientInfo()
        await this.$validator.validateAll()
        let ValidateDisclaimerConsent = await this.$refs.ConsentDisclaimer.validate()
        this.signature = this.$store.state.consentSignature
        let ScheduleSection
        if (this.$store.state.site.schedule.data.length && this.$store.state.configs.ALLOW_SCHEDULES) {
          ScheduleSection = await this.$refs.ScheduleSection.validate()
        } else {
          ScheduleSection = true
        }
        if (this.$validator.errors.items.length) {
          if (this.optionsArray.length <= 4) {
            //  document.getElementsByName(this.$validator.errors.items[0].field)[0].childNodes[0].focus()
            document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
          } else {
            document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
          }
          this.dependentError = 'Please select a patient'
          return false
        } else {
          this.dependentError = ''
        }
        this.submit = true
        this.finalResponse = {}
        await this.$refs.MedicalData.validate()
        this.questionError = this.$refs.questions.validate() === '' ? '' : false
        // call validation for questions
        let validator = true
        this.questionError = ''
        if (this.$store.state.questions !== []) {
          let questionValidation = this.validateQuestions(this.$store.state.questions, validator)
          if (questionValidation === false) {
            this.questionError = this.computeCaption(this.fields_en['all_questions'], this.$store.state.lang.value.toLowerCase())
            if (this.$validator.errors.items.length === 0 && !this.errorDate) {
              let firstQuestionDOM = ''
              for (let iteration = 0; iteration <= 100; iteration++) {
                firstQuestionDOM = document.getElementsByName('question_' + iteration)
                if (firstQuestionDOM !== '' && firstQuestionDOM !== undefined && firstQuestionDOM.length !== 0) {
                  break
                }
              }
              if (firstQuestionDOM !== '' && firstQuestionDOM !== undefined) {
                if (firstQuestionDOM[0].childNodes.length === 0) {
                  firstQuestionDOM[0].focus()
                } else {
                  firstQuestionDOM[0].childNodes[0].focus()
                }
              }
            }
            return false
          }
        }
        if (this.allow_insurance) {
          await this.$refs.Insurance.validate()
        } else {
          this.$store.state.insuranceValidator = true
        }
        if ((this.$store.state.configs['FORCE_PAYMENT_ON_REGISTRATION'] === true && this.$store.state.insuranceType === 'cash' && this.$store.state.cashPayment === 'card') || this.$store.state.configs['AT_HOME_COLLECTION'] === true) {
          let ValidatePayment = await this.$refs.paymentSectionVisible.validate()
          if (ValidatePayment.valid !== false) {
            this.finalResponse = {...this.finalResponse, ...ValidatePayment}
          } else {
            return false
          }
        }
        if ((await this.$validator.validateAll() === true) && ScheduleSection && ValidateDisclaimerConsent && this.$store.state.insuranceValidator && this.$store.state.medDataValidator && this.questionError === '') {
          this.finalResponse = {...this.finalResponse, ...this.$store.state.currentData}
          this.finalResponse.questions = this.$store.state.questions
          this.finalResponse.appointment_date = ScheduleSection.appointment_date
          this.finalResponse.appointment_slot_id = ScheduleSection.appointment_slot_id
          if (this.model.dependent === 'Self') {
            this.finalResponse.patient = 'Self'
          } else {
            this.finalResponse.patient = this.$store.state.currentData.id
          }
          this.finalResponse['paid_cash'] = this.$store.state.cashPayment
          this.finalResponse['redirect_payment_url'] = this.$store.state.redirect_payment_url
          this.finalResponse.signature = this.signature
          this.finalResponse.siteCode = this.$store.state.sitecode
          this.finalResponse.patient_support_info = this.$store.state.configs.PATIENT_SUPPORT_INFO
          this.finalResponse = _.mergeWith(this.$store.state.registrationInsuranceData, this.finalResponse, this.customizer)
          this.finalResponse.info = info
          this.disabledButton = true
          const self = this
          axios.post(process.env.SERVER_URI + '/account/new/registration', this.finalResponse, {headers: {'Authorization': `Bearer ${localStorage.getItem('token')}`}})
              .then((response) => {
                if (response.data.schedule) {
                  swal({
                    html: `<h4>` + response.data.schedule + `</h4>
                           <br>`,
                    icon: 'error',
                    type: 'error',
                    confirmButtonText: 'Ok',
                    showCancelButton: false,
                    showConfirmButton: true,
                    width: 700
                  })
                  this.disabledButton = false
                  return
                }
                if (response.data === false) {
                  this.disabledButton = false
                  this.errorSave = 'There was an error submitting the data'
                } else {
                  if (response.data['template'] === undefined && response.data.includes('card')) {
                    swal('Error!', response.data, 'error')
                    self.redirect()
                    return
                  }
                  if (response.data['template'] === undefined) {
                    swal('Error!', 'There was an error submitting the data', 'error')
                    self.redirect()
                    return
                  }
                  if (this.$store.state.cashPayment && (this.$store.state.configs['FORCE_PAYMENT_ON_REGISTRATION'] === false && this.$store.state.configs['AT_HOME_COLLECTION'] === false)) {
                    // redirect to custom payment
                    if (this.$store.state.redirect_payment_url) {
                      window.location.href = this.$store.state.redirect_payment_url + response.data['confirmation_number']
                    } else {
                      this.$router.push({ name: 'PaymentWizard', params: {id: response.data['confirmation_number']} })
                    }
                  } else {
                    let template = response.data['template']
                    this.confirmationNumber = response.data['confirmation_number']
                    this.redirectUrl = ''
                    let url = this.$store.state.redirect_registration_url
                    setTimeout(() => {
                      swal({
                        html: template + `
                               </b>
                           <br>
                           <div class="flex">
                          <button type="button" style="background: #509119" class="btn-modal btn-complete">` + this.computeCaption('Complete', this.$store.state.lang.value.toLowerCase()) + `</button>
                          <button type="button" style="background: #0E62AA" class="btn-modal btn-new-patient">` + this.computeCaption('Register New Patient', this.$store.state.lang.value.toLowerCase()) + `</button>
                          </div>`,
                        showCancelButton: false,
                        showConfirmButton: false,
                        width: 700,
                        onBeforeOpen: () => {
                          const complete = document.querySelector('.btn-complete')
                          const patient = document.querySelector('.btn-new-patient')

                          complete.addEventListener('click', () => {
                            if (url !== undefined) {
                              if (!url.includes('{{')) {
                                window.location.assign(url)
                              }
                            } else {
                              window.location.assign(window.origin + '/#/')
                              window.location.reload()
                            }
                            swal.close()
                          })

                          patient.addEventListener('click', () => {
                            window.location.href = window.origin + '/#/patient/account/form/registration'
                            window.location.reload()
                            swal.close()
                          })
                        }
                      }).catch(swal.noop)
                    }, 1000)
                  }
                }
              }).catch(error => {
                console.log(error)
                this.disabledButton = false
                this.errorSave = 'There was an error submitting the data'
              })
        }
      },
      createFilter (queryString) {
        return (link) => {
          return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      redirect () {
        const body = document.querySelector('body')
        body.onclick = function () {
          window.location.reload()
        }
      },
      async prepareData () {
        let one = process.env.SERVER_URI + '/validate/site/' + this.$store.state.sitecode
        let two = process.env.SERVER_URI + '/questions/' + this.$store.state.sitecode
        let four = process.env.SERVER_URI + '/insurance/' + this.$store.state.sitecode
        let five = process.env.SERVER_URI + '/requirements/' + this.$store.state.sitecode
        let six = process.env.SERVER_URI + '/ethnicity/' + this.$store.state.sitecode
        let seven = process.env.SERVER_URI + '/race/' + this.$store.state.sitecode
        let eigth = process.env.SERVER_URI + '/gender/' + this.$store.state.sitecode
        let nine = process.env.SERVER_URI + '/account/get/dependents'
        let ten = process.env.SERVER_URI + '/account/check/user'
        let eleven = process.env.SERVER_URI + '/calculations/' + this.$store.state.sitecode
        let email = localStorage.getItem('email')
        const requestOne = axios.get(one)
        const requestTwo = axios.get(two)
        const requestFour = axios.get(four)
        const requestFive = axios.get(five)
        const requestSix = axios.get(six)
        const requestSeven = axios.get(seven)
        const requestEigth = axios.get(eigth)
        const requestNine = axios.post(nine, {'email': email}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        const requestTen = axios.post(ten, {'email': email}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        const requestEleven = axios.get(eleven)
        await axios.all([requestOne, requestFour, requestTwo, requestFive, requestSix, requestSeven, requestEigth, requestNine, requestTen, requestEleven])
            .then(axios.spread((...responses) => {
              this.$store.state.site = responses[0].data
              this.$store.state.insurance = responses[1].data
              this.$store.state.requirements = {...this.$store.state.requirements, ...responses[3].data}
              this.$store.state.configs.ALLOW_DRIVER_LICENSE = this.$store.state.requirements.driver_license_image && this.$store.state.requirements.driver_license_image !== ''
              this.$store.state.configs.REQUIRED_DRIVER_LICENSE = this.checkRequirement('driver_license_image')
              this.$store.state.configs.ALLOW_INSURANCE_CARD = this.$store.state.requirements.insurance_card_image && this.$store.state.requirements.insurance_card_image !== ''
              this.$store.state.configs.REQUIRED_INSURANCE_CARD = this.checkRequirement('insurance_card_image')
              this.$store.state.ethnicity = responses[4].data
              this.$store.state.race = responses[5].data
              this.$store.state.gender = responses[6].data
              this.$store.state.calculations = responses[9].data
              this.$store.state.questions = []
              if (this.$store.state.site.insurance_name_insured.length && this.$store.state.site.insurance_name_insured[0].length > 0) {
                if (this.$store.state.requirements.gender) {
                  this.$store.state.requirements.gender.required_portal = '1'
                } else {
                  this.$store.state.requirements.gender = []
                  this.$store.state.requirements.gender.required_portal = '1'
                }
                if (this.$store.state.requirements.address) {
                  this.$store.state.requirements.address.required_portal = '1'
                } else {
                  this.$store.state.requirements.address = []
                  this.$store.state.requirements.address.required_portal = '1'
                }
              }
              if (responses[2].data) {
                for (let key in responses[2].data.data.questions) {
                  if (parseInt(key) !== responses[2].data.data.questions.length) {
                    responses[2].data.data.questions[key].multiple = []
                    responses[2].data.data.questions[key].multiple_ids = []
                    this.$store.state.questions.push(responses[2].data.data.questions[key])
                  }
                }
              }
              if (this.$store.state.site['required_dl_or_ssn'] === true || this.$store.state.site['required_dl_or_ssn'] === false) {
                this.$store.state.dl_or_ssn_required_by_client = this.$store.state.site['required_dl_or_ssn']
              }
              if (this.$store.state.site['allow_dl_or_ssn'] === true || this.$store.state.site['allow_dl_or_ssn'] === false) {
                this.$store.state.allow_dl_or_ssn = this.$store.state.site['allow_dl_or_ssn']
              }
              if (this.$store.state.site['required_uninsured_ssn'] === true || this.$store.state.site['required_uninsured_ssn'] === false) {
                this.$store.state.required_uninsured_ssn = this.$store.state.site['required_uninsured_ssn']
              }
              if (this.$store.state.site['required_insurance_ssn'] === true || this.$store.state.site['required_insurance_ssn'] === false) {
                this.$store.state.required_insurance_ssn = this.$store.state.site['required_insurance_ssn']
              }
              if (responses[0].data['redirect_registration_url']) {
                this.$store.state.redirect_registration_url = responses[0].data['redirect_registration_url']
              }
              if (responses[0].data['redirect_payment_url']) {
                this.$store.state.redirect_payment_url = responses[0].data['redirect_payment_url']
              }
              this.overwriteGraphSettings(responses[0].data)
              if (responses[8].data === false) {
                this.$store.state.userData = {
                  driver_license_image: '',
                  driver_license_name: '',
                  firstName: '',
                  lastName: '',
                  passport: '',
                  dob: '',
                  dob_pretty: '',
                  address: '',
                  address2: '',
                  gender: '',
                  phone: '',
                  race: '',
                  ethnicity: '',
                  addressComponents: '',
                  primary_insurance: '',
                  policy_number: '',
                  group_number: '',
                  driver_license_number: '',
                  social_number: ''
                }
              } else if (responses[8].data) {
                let addressInitial = {}
                if (responses[8].data['addressComponents']) {
                  addressInitial = {
                    name: responses[8].data['addressComponents']['name'] || '',
                    original_name: responses[8].data['addressComponents']['original_name'] || '',
                    delivery_line_1: responses[8].data['addressComponents']['delivery_line_1'] || '',
                    city_name: responses[8].data['addressComponents']['city_name'] || '',
                    county: responses[8].data['addressComponents']['county'] || '',
                    state_abbreviation: responses[8].data['addressComponents']['state_abbreviation'] || '',
                    zipcode: responses[8].data['addressComponents']['zipcode'] || '',
                    plus4_code: responses[8].data['addressComponents']['plus4_code'] || '',
                    county_fips: responses[8].data['addressComponents']['county_fips'] || '',
                    country: responses[8].data['addressComponents']['country'] || ''
                  }
                }
                let insuredAddressInitial = {}
                if (responses[8].data['insured_address_components']) {
                  insuredAddressInitial = {
                    name: responses[8].data['insured_address_components']['name'] || '',
                    original_name: responses[8].data['insured_address_components']['original_name'] || '',
                    delivery_line_1: responses[8].data['insured_address_components']['delivery_line_1'] || '',
                    city_name: responses[8].data['insured_address_components']['city_name'] || '',
                    county: responses[8].data['insured_address_components']['county'] || '',
                    state_abbreviation: responses[8].data['insured_address_components']['state_abbreviation'] || '',
                    zipcode: responses[8].data['insured_address_components']['zipcode'] || '',
                    plus4_code: responses[8].data['insured_address_components']['plus4_code'] || '',
                    county_fips: responses[8].data['insured_address_components']['county_fips'] || '',
                    country: responses[8].data['insured_address_components']['country'] || ''
                  }
                }
                this.$store.state.userData = {
                  firstName: responses[8].data['first_name'] || '',
                  lastName: responses[8].data['last_name'] || '',
                  middleName: responses[8].data['middle_name'] || '',
                  passport: responses[8].data['passport'] || '',
                  dob: responses[8].data['date_of_birth'] || '',
                  dob_pretty: responses[8].data['date_of_birth'] || '',
                  address: responses[8].data['address'] || '',
                  address2: responses[8].data['address2'] || '',
                  gender: responses[8].data['gender'] || '',
                  phone: responses[8].data['phone'] || '',
                  race: responses[8].data['race'] || '',
                  ethnicity: responses[8].data['ethnicity'] || '',
                  addressComponents: addressInitial,
                  primary_insurance: responses[8].data['insurance_name'] || '',
                  policy_number: responses[8].data['policy_number'] || '',
                  group_number: responses[8].data['group_number'] || '',
                  driver_license_number: responses[8].data['driver_license_number'] || '',
                  social_number: responses[8].data['social_number'] || '',
                  insured_first_name: responses[8].data['insured_first_name'] || '',
                  insured_last_name: responses[8].data['insured_last_name'] || '',
                  insured_middle_name: responses[8].data['insured_middle_name'] || '',
                  insured_gender: responses[8].data['insured_gender'] || '',
                  insured_date_of_birth: responses[8].data['insured_date_of_birth'] || '',
                  insured_date_of_birth_pretty: responses[8].data['insured_date_of_birth'] || '',
                  insured_address_components: insuredAddressInitial || '',
                  insured_address: responses[8].data['insured_address'] || '',
                  insured_address2: responses[8].data['insured_address2'] || '',
                  relationship: responses[8].data['relationship'] || ''
                }
              }
              if (responses[7].data === false) {
                this.$store.state.dependentsData = []
              } else if (responses[7].data) {
                this.$store.state.dependentsData = responses[7].data
              }
              this.$store.state.patientRegistrationData = this.$store.state.userData
              this.$store.state.userData = {
                driver_license_image: '',
                driver_license_name: '',
                firstName: '',
                lastName: '',
                passport: '',
                dob: '',
                dob_pretty: '',
                address: '',
                address2: '',
                gender: '',
                phone: '',
                race: '',
                ethnicity: '',
                addressComponents: '',
                primary_insurance: '',
                policy_number: '',
                group_number: '',
                driver_license_number: '',
                social_number: ''
              }
              this.view = true
              return true
            })).catch(error => {
              console.log(error)
              this.view = false
              return false
            })
      }
    },
    computed: {
      ...mapFields(['dependent', 'questions']),
      allow_insurance () {
        return this.$store.state.configs.ALLOW_INSURANCE
      }
    },
    watch: {
      'model.dependent': {
        handler: function (after, before) {
          if (this.model.dependent) {
            this.validatedSectionClass = 'validated-section-class'
            this.generalClass = 'general-inactive-section'
          }
          this.dependentError = ''
          if (this.model.dependent === 'Self') {
            this.$store.state.userData = this.$store.state.patientRegistrationData
            this.$store.state.dependentSelected = false
          } else {
            this.$store.state.dependentSelected = true
            let id
            for (id in this.$store.state.dependentsData) {
              if (this.model.dependent === this.$store.state.dependentsData[id]['first_name'] + ' ' + this.$store.state.dependentsData[id]['last_name']) {
                let addressInitial = {}
                this.dependentsArray = this.$store.state.dependentsData
                if (this.dependentsArray[id]['addressComponents']) {
                  addressInitial = {
                    name: this.dependentsArray[id]['addressComponents']['name'] || '',
                    original_name: this.dependentsArray[id]['addressComponents']['original_name'] || '',
                    delivery_line_1: this.dependentsArray[id]['addressComponents']['delivery_line_1'] || '',
                    city_name: this.dependentsArray[id]['addressComponents']['city_name'] || '',
                    county: this.dependentsArray[id]['addressComponents']['county'] || '',
                    state_abbreviation: this.dependentsArray[id]['addressComponents']['state_abbreviation'] || '',
                    zipcode: this.dependentsArray[id]['addressComponents']['zipcode'] || '',
                    plus4_code: this.dependentsArray[id]['addressComponents']['plus4_code'] || '',
                    county_fips: this.dependentsArray[id]['addressComponents']['county_fips'] || '',
                    country: this.dependentsArray[id]['addressComponents']['country'] || ''
                  }
                }
                let insuredAddressInitial = {}
                if (this.dependentsArray[id]['insured_address_components']) {
                  insuredAddressInitial = {
                    name: this.dependentsArray[id]['insured_address_components']['name'] || '',
                    original_name: this.dependentsArray[id]['insured_address_components']['original_name'] || '',
                    delivery_line_1: this.dependentsArray[id]['insured_address_components']['delivery_line_1'] || '',
                    city_name: this.dependentsArray[id]['insured_address_components']['city_name'] || '',
                    county: this.dependentsArray[id]['insured_address_components']['county'] || '',
                    state_abbreviation: this.dependentsArray[id]['insured_address_components']['state_abbreviation'] || '',
                    zipcode: this.dependentsArray[id]['insured_address_components']['zipcode'] || '',
                    plus4_code: this.dependentsArray[id]['insured_address_components']['plus4_code'] || '',
                    county_fips: this.dependentsArray[id]['insured_address_components']['county_fips'] || '',
                    country: this.dependentsArray[id]['insured_address_components']['country'] || ''
                  }
                }

                this.$store.state.userData = {
                  firstName: this.dependentsArray[id]['first_name'] || '',
                  lastName: this.dependentsArray[id]['last_name'] || '',
                  middleName: this.dependentsArray[id]['middle_name'] || '',
                  passport: this.dependentsArray[id]['passport'] || '',
                  dob: this.dependentsArray[id]['date_of_birth'] || '',
                  dob_pretty: this.dependentsArray[id]['date_of_birth'] || '',
                  address: this.dependentsArray[id]['address'] || '',
                  address2: this.dependentsArray[id]['address2'] || '',
                  gender: this.dependentsArray[id]['gender'] || '',
                  phone: this.dependentsArray[id]['phone'] || '',
                  race: this.dependentsArray[id]['race'] || '',
                  ethnicity: this.dependentsArray[id]['ethnicity'] || '',
                  addressComponents: addressInitial,
                  primary_insurance: this.dependentsArray[id]['insurance_name'] || '',
                  policy_number: this.dependentsArray[id]['policy_number'] || '',
                  group_number: this.dependentsArray[id]['group_number'] || '',
                  driver_license_number: this.dependentsArray[id]['driver_license_number'] || '',
                  social_number: this.dependentsArray[id]['social_number'] || '',
                  insured_same_as: this.dependentsArray[id]['insurance_same_as'] || '',
                  insured_first_name: this.dependentsArray[id]['insured_first_name'] || '',
                  insured_middle_name: this.dependentsArray[id]['insured_middle_name'] || '',
                  insured_last_name: this.dependentsArray[id]['insured_last_name'] || '',
                  insured_date_of_birth: this.dependentsArray[id]['insured_date_of_birth'] || '',
                  insured_date_of_birth_pretty: this.dependentsArray[id]['insured_date_of_birth_pretty'] || '',
                  insured_address: this.dependentsArray[id]['insured_address'] || '',
                  insured_address2: this.dependentsArray[id]['insured_address2'] || '',
                  relationship: this.dependentsArray[id]['relationship'] || '',
                  insured_gender: this.dependentsArray[id]['insured_gender'] || '',
                  insured_address_components: insuredAddressInitial,
                  id: this.dependentsArray[id]['id']
                }
              }
            }
          }
          this.newDependentSelected = false
          this.$nextTick(() => {
            this.newDependentSelected = true
          })
        }
      }
    },
    async beforeMount () {
      await this.prepareData()
      let id
      for (id in this.$store.state.dependentsData) {
        this.optionsArray.push({name: this.$store.state.dependentsData[id]['first_name'] + ' ' + this.$store.state.dependentsData[id]['last_name']})
      }
      if (this.optionsArray.length === 1) {
        this.model.dependent = 'Self'
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "../../../../../assets/sass/paper/_variables.scss";

.el-select--large {
  width: 100%;
}

.el-autocomplete {
  width: 100%;
}

h4 {
  margin-bottom: 15px;
  font-weight: normal;
}

.display-none {
  display: none;
}

.generic-answer {
  margin-top: 10px;
}

.float-right {
  float: right;
}

.patient-float {
  text-align: right;
}

.p-0 {
  padding: 0;
}

.w-100 {
  width: 100% !important;
}

.pl-5 {
  padding-left: 5px;
}

.pr-5 {
  padding-right: 5px;
}

.p-10 {
  padding: 10px;
}

.pt-10 {
  padding-top: 10px;
}

.d-inline-block {
  display: inline-block;
}

.mt-5 {
  margin-top: 5px;
}

.mt-10 {
  margin-top: 10px;
}

.upload-file {
  width: 0;
  height: 0;
}

.upload-file-label {
  display: block;
  color: white;
  padding: 10px;
  text-align: center;
  border-radius: 6px;
}

.elipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  width: auto;
  height: 1.2em;
  white-space: nowrap;
}

.text-none {
  text-transform: none;
  font-size: 14px;
}

.general-inactive-section:focus-within {
  border-left-color: $primary-color !important;
}

@media screen and (max-width: 991px) {
  .mt-5 {
    margin-top: 0;
  }
  .patient-float {
  text-align: left;
  }
  .mb-0 {
    margin-bottom: 0;
  }
  .button {
    float: left;
    width: 100% !important;
  }
  .button-back {
    margin-bottom: 2px;
    float: left;
    width: 100% !important;
  }
  .pr-0 {
    padding-left: 0;
  }
}

@media screen and (max-width: 365px) {
  >>> .el-radio-button--small .el-radio-button__inner {
    padding: 9px 7px;
  }
  .button {
    float: left;
    width: 100% !important;
  }
  .button-back {
    margin-bottom: 2px;
    float: left;
    width: 100% !important;
  }
}

@media screen and (max-width: 420px) {
  .button-container {
    display: grid;
  }
  .button-container > .back-button{
    grid-row: 2 !important;
  }
  .button-container > .next-button{
    grid-row: 1 !important;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/Dashboard/Registration.vue